export default {"src":"/_next/static/media/icon_list_clickedV2.489899d8.svg","height":27,"width":25,"blurWidth":0,"blurHeight":0};